import { render, staticRenderFns } from "./WhereToFind.vue?vue&type=template&id=5306ab07&scoped=true&lang=pug&"
import script from "./WhereToFind.vue?vue&type=script&lang=js&"
export * from "./WhereToFind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306ab07",
  null
  
)

export default component.exports